var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopularInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#fff;}.cls-3{fill:#fffefd;}.cls-4{fill:#e6be8a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "popular-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Populares"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 6.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.64 16 14.71 26.31 25.79 16 23.91 16 14.71 24.55 5.63 16 3.64 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.79 13.31 14.71 3 3.64 13.31 5.52 13.31 14.71 4.76 23.8 13.31 25.79 13.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.59,11.55h-.05a3.56,3.56,0,0,0,0,6.9,3.58,3.58,0,0,0,.07-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.06,11.34l-.1,0-.14,0a3.71,3.71,0,0,0-.67-.06,4.14,4.14,0,0,0-.87.1,3.71,3.71,0,0,1-.08,7.19h.05l.15,0a3.66,3.66,0,0,0,.75.09,3.71,3.71,0,0,0,.91-7.3Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularInactive);
export default __webpack_public_path__ + "static/media/popular-inactive.a92b38c69071bc7f19e2f720d87012d6.svg";
export { ForwardRef as ReactComponent };